import { render, staticRenderFns } from "./ChosenDatasets.vue?vue&type=template&id=1fcf6f3c&"
import script from "./ChosenDatasets.vue?vue&type=script&lang=js&"
export * from "./ChosenDatasets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports